import { Component } from '@angular/core';
import { LoginWrapperComponent } from 'gung-standard';

@Component({
    selector: 'sjoborg-login-wrapper',
    templateUrl: './sjoborg-login-wrapper.component.html',
    styleUrls: ['./sjoborg-login-wrapper.component.scss'],
    standalone: false
})
export class SjoborgLoginWrapperComponent extends LoginWrapperComponent {}
